import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import Preloader from "@/components/Preloader";
import PartnerMarquee from "@/components/PartnerMarquee";
import ServicesSection from "@/components/ServicesSection";
import ColorInMotion from "@/components/ColorInMotion";
import GallerySection from "@/components/GallerySection";
import ManifestoSection from "@/components/ManifestoSection";
import CareersSection from "@/components/CareersSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ContactQuoteSection from "@/components/ContactQuoteSection";
import Footer from "@/components/Footer";

export default function Home({ theme, toggleTheme }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.body.style.overflow = loading ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [loading]);

  return (
    <main>
      <AnimatePresence>
        {loading && <Preloader onDone={() => setLoading(false)} />}
      </AnimatePresence>
      <Navbar theme={theme} toggleTheme={toggleTheme} />
      {!loading && <HeroSection />}
      <PartnerMarquee />
      <ServicesSection />
      <ColorInMotion />
      <GallerySection />
      <ManifestoSection />
      <CareersSection />
      <TestimonialsSection />
      <ContactQuoteSection />
      <Footer />
    </main>
  );
}
